import "@/styles/components/slide-toggle.css";
import delegate from "delegate-it";
import { fireEvent } from "@/scripts/common/util";
import { slideToggle } from "@/scripts/common/slide";

const SELECTORS = {
  slideToggle: "[data-slide-toggle]",
  slideToggleHolder: "[data-slide-toggle-holder]",
};

const EVENTS = {
  open: "slidetoggle:open",
  close: "slidetoggle:close",
  reset: "slidetoggle:reset",
};

const handleToggle = async (event) => {
  const { target } = event;

  const trigger = target.closest(SELECTORS.slideToggle);
  if (!trigger) return;

  const controlsId = trigger.getAttribute("aria-controls");
  if (!controlsId) return;

  const targetElement = document.getElementById(controlsId);
  if (!targetElement) return;

  const isExpanded = trigger.getAttribute("aria-expanded") === "true";

  // Select all triggers controlling the same target
  const allTriggers = Array.from(document.querySelectorAll(`${SELECTORS.slideToggle}[aria-controls="${controlsId}"]`));

  // Toggle ARIA attributes
  allTriggers.forEach((el) => el.setAttribute("aria-expanded", String(!isExpanded)));

  // Toggle active classes
  const holder = trigger.closest(SELECTORS.slideToggleHolder);
  const parentNodes = holder ? [holder] : allTriggers.map((el) => el.parentNode);

  parentNodes.forEach((node) => node.classList.toggle("is-active", !isExpanded));

  // Perform the slide toggle animation
  await slideToggle(targetElement);

  // Fire appropriate custom event
  fireEvent(isExpanded ? EVENTS.close : EVENTS.open, document.documentElement, { trigger });
};

const handleReset = (event) => {
  handleToggle(event);
};

export default {
  init: () => {
    delegate(SELECTORS.slideToggle, "click", handleToggle);
    delegate(SELECTORS.slideToggle, EVENTS.reset, handleReset);
  },
};
